<template>
  <div id="menu">
    <div class=" fw fz16 ml50 flex">
<!--      :class=" changeBox == 'home' ? 'menu-item' : 'menu-item-dark'" -->
      <div id="home" class="menu-item">首页</div>
      <div id="product" class="menu-item" v-if="changeBox != 'product'">产品</div>
      <div id="product" class="menu-item-dark" v-if="changeBox == 'product'">产品</div>
      <div id="case" class="menu-item" v-if="changeBox != 'case'">案例</div>
      <div id="case" class="menu-item-dark" v-if="changeBox == 'case'">案例</div>
      <div id="service" class="menu-item" v-if="changeBox != 'service'">服务</div>
      <div id="service" class="menu-item-dark" v-if="changeBox == 'service'">服务</div>
      <div id="cooperate" class="menu-item" v-if="changeBox != 'cooperate'" @click="jumpTo('/contactUs')">生态合作</div>
      <div id="cooperate" class="menu-item-dark" v-if="changeBox == 'cooperate'" @click="jumpTo('/contactUs')">生态合作</div>
      <div id="us" class="menu-item" v-if="changeBox != 'us'" @click="jumpTo('/about')">关于我们</div>
      <div id="us" class="menu-item-dark" v-if="changeBox == 'us'" @click="jumpTo('/about')">关于我们</div>
      <div id="openness" class="menu-item" v-if="changeBox != 'openness'">开放平台</div>
      <div id="openness" class="menu-item-dark" v-if="changeBox == 'openness'">开放平台</div>
    </div>

    <div class="sub-menu-item" v-if="changeBox == 'product'" id="product">
      <div class="cp-head-con">
        <div class="changeColor">
          电子签章
        </div>
        <div class="cp-title">
          系统
        </div>
      </div>
      <div class="flex">
        <div class="product-box mr20">
          <div class="product-header" style="">
            <div class="fz14">企业版</div>
            <div class="fz12" style="margin-top: 7px">面向大型/超大型企业</div>
          </div>
          <div class="cp-ability-con">
            <div class="cp-ability-item">·私有部署</div>
            <div class="cp-ability-item">·印章管理</div>
            <div class="cp-ability-item">·定制化开发</div>
            <div class="cp-ability-item">·独立运维</div>
          </div>
          <div class="btn-con">

          </div>
        </div>
        <div class="product-box mr20">
          <div class="product-header" style="">
            <div class="fz14">政务版</div>
            <div class="fz12" style="margin-top: 7px">面向党政机关印章基础设施</div>
          </div>
          <div class="cp-ability-con">
            <div class="cp-ability-item">·基础设施整合</div>
            <div class="cp-ability-item">·私有证书管理</div>
            <div class="cp-ability-item">·多通道多服务</div>
            <div class="cp-ability-item">·定制化开发</div>
          </div>
          <div class="btn-con">

          </div>
        </div>
      </div>
    </div>

    <div class="sub-menu-item flex" v-if="changeBox == 'service'" id="service">
      <div class="sub-fw">
        <div class="fw-title">工具</div>
        <div>
          <div class="fw-card" @click="jumpTo('/verifyTruth')">文档验签</div>
        </div>
      </div>

      <div class="sub-fw">
        <div class="fw-title">安全合规</div>
        <div>
          <div class="fw-card">政策法规</div>
        </div>
      </div>

      <div class="sub-fw">
        <div class="fw-title">客户服务</div>
        <div>
          <div class="fw-card">常见问题</div>
        </div>
      </div>
    </div>

<!--    <div class="sub-menu-item" v-if="changeBox == 'cooperate'" id="cooperate">-->

<!--    </div>-->

  </div>

</template>

<script>

export default {
  name: "header-menu",
  data() {
    return {
      changeBox: null,
    }
  },
  mounted() {
    var menu = document.getElementById('menu')
    let _this = this
    menu.addEventListener('mouseover', function(e) {
      // 鼠标移入元素时触发的代码
      if (e.target.id){
        _this.$set(_this , 'changeBox' , e.target.id)
      }
      // console.log('鼠标移入元素' , e.target.className , e.target.id , e);
    });


    menu.addEventListener('mouseleave', function(e) {
      // 鼠标移入元素时触发的代码
      // if (e.target.id == _this.changeBox && e.relatedTarget.className == 'top-area'){
      //   _this.$set(_this , 'changeBox' , null)
      // }
      _this.$set(_this , 'changeBox' , null)
      // console.log('鼠标移出元素', e.target.id , e);
    });
  },
  methods:{
    jumpTo(url){
      this.$router.push({
          path: url,
      });
    }
  }
}
</script>

<style scoped lang="less">
.menu-item:hover {
  background-color: #F4F4F4; /* 鼠标悬停时的背景颜色 */
  cursor: pointer; /* 鼠标悬停时显示的手形光标 */
}

.menu-item{
  padding: 6px 16px;
}

.menu-item-dark{
  padding: 6px 16px;
  background-color: #F4F4F4; /* 鼠标悬停时的背景颜色 */
  cursor: pointer; /* 鼠标悬停时显示的手形光标 */
}

::v-deep .sub-menu-item{
  background-color: rgba(255, 255, 255, 1);
  width: 100%;
  height: 500px;
  position: absolute;
  left: 0;
  top: 53px;
  padding-left: 50px;
  padding-top: 30px;
}

.product-box{
  width: 330px;
  height: 200px;
  border-radius: 10px;
  background-color: #FFFFFF;
  box-shadow: 0 2px 14px 0 rgba(205,218,230,.8);

  .product-header{
    width: 100%;
    height: 75px;
    background: linear-gradient(90deg, #EBF2FF 0%, #A3D3FF 45%, #6999FF 100%);
    border-radius: 8px 8px 0 0;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 15px 20px;
  }
}

.cp-head-con{
  margin-bottom: 3px;
  display: flex;
  align-items: flex-end;

  .changeColor{
    font-family: PingFangSC,PingFang SC;
    font-weight: 600;
    font-size: 20px;
    line-height: 29px;
    padding-right: 4px;
    font-style: normal;
    background: linear-gradient(90deg,#ff6161,#6f23ff);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .cp-title{
    font-family: PingFangSC,PingFang SC;
    font-weight: 600;
    font-size: 16px;
    color: rgba(0,0,0,.85);
    line-height: 24px;
    font-style: normal;
    padding-right: 20px;
    display: inline-block;
  }
}

.cp-ability-con{
  box-sizing: border-box;
  padding-left: 20px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  margin-top: 10px;
  width: 100%;

  .cp-ability-item{
    width: 43%;
    margin-right: 2%;
    height: 14px;
    font-family: PingFangSC,PingFang SC;
    font-weight: 500;
    font-size: 12px;
    color: rgba(0,0,0,.55);
    line-height: 14px;
    text-align: left;
    font-style: normal;
    margin-bottom: 12px;
  }
}

.sub-fw{
  margin-right: 30px;
  margin-bottom: 10px;
  width: 215px;
  height: 238px;
  background: #fff;
  box-shadow: 0 4px 12px 0 rgba(210, 215, 223, 0.5);
  border-radius: 4px;
  box-sizing: border-box;
  padding: 16px 20px;

  .fw-title{
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 16px;
    color: rgba(0, 0, 0, 0.85);
    line-height: 24px;
    text-align: left;
    font-style: normal;
    display: inline-block;
    margin-bottom: 24px;
    width: 100%;
  }

  .fw-card{
    width: 130px;
    text-align: center;
    margin-bottom: 28px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    position: relative;
  }
}
</style>
